import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faStar,
  faThumbsUp,
  faThumbsDown,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faStar,
  faThumbsUp,
  faThumbsDown,
);

Vue.component('font-awesome-icon', FontAwesomeIcon)
